import React, {Component} from "react";
import BigLogo from "./../../../assets/images/big-logo.png";
import {Link} from "react-router-dom";

class PageNotFound extends Component {
	render() {
		return (
			<div className="page">
				<div className="page__title">404 - Страница не существует</div>
				<div className="page__data">
					<div className="about">
						<div className="about__biglogo">
							<Link to={'/'}>
								<img src={BigLogo} alt="Букмекерская компания Maxline"/>
							</Link>
						</div>
						<div className="about__description block">
							<p>Букмекерская компания Maxline открывает перед своими клиентами мир безграничных
								возможностей.
								Любите спорт? Следите за новостями в этой области? Значит, вы можете предположить, какая
								команда или отдельный спортсмен окажется лучше других. Онлайн ставки на спорт помогут
								вашим предположениям превратиться в реальные деньги.</p>
							<p>Онлайн ставки на спорт вместе с Maxline экономят время. Всего за несколько кликов вы
								будете вовлечены в удивительный мир спортивных соревнований, взлётов и падений, надежд и
								разочарований.</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/app/pages/Page/PageNotFound.js